import React, { useState, useEffect } from 'react';
import { Button, Menu, MenuItem } from '@material-ui/core';
import axios from "axios";
import envConfig from "../../../bin/env.config";

const BannerSelector = ({ 
  project_id, 
  token, 
  selectedBanners, 
  onBannerSelect,
  style = {}
}) => {
  const [banners, setBanners] = useState([]);
  const [bannerAnchorEl, setBannerAnchorEl] = useState(null);

  const fetchBanners = async () => {
    try {
      const response = await axios.post(
        `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/project-banners`,
        {
          project_id: project_id,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      
      // Filter banners based on project_id
      const filteredBanners = response.data.data.filter(banner => 
        banner.company_report_tool_project_id === parseInt(project_id)
      );
      setBanners(filteredBanners);
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  useEffect(() => {
    if (project_id) {
      fetchBanners();
    }
  }, [project_id]);

  const handleBannerClick = (event) => {
    setBannerAnchorEl(event.currentTarget);
  };

  const handleBannerClose = () => {
    setBannerAnchorEl(null);
  };

  const handleBannerSelect = (banner) => {
    onBannerSelect(banner);
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleBannerClick}
        style={{ minWidth: 200, justifyContent: 'flex-start', marginRight: '16px', ...style }}
      >
        {selectedBanners.length > 0 
          ? `${selectedBanners.length} Banner${selectedBanners.length > 1 ? 's' : ''} Selected`
          : 'All Banners'}
      </Button>
      <Menu
        anchorEl={bannerAnchorEl}
        keepMounted
        open={Boolean(bannerAnchorEl)}
        onClose={handleBannerClose}
        PaperProps={{
          style: {
            maxHeight: 300,
            width: '250px',
          },
        }}
      >
        <MenuItem onClick={() => handleBannerSelect('')}>
          <em>Clear All</em>
        </MenuItem>
        {banners.map((banner) => (
          <MenuItem 
            key={banner.id} 
            onClick={() => handleBannerSelect(banner.id)}
            selected={selectedBanners.includes(banner.id)}
          >
            {banner.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default BannerSelector; 